import React from 'react';
import { Loader2, Heart, Sparkles } from 'lucide-react';

const LoadingWrapper = ({
  loading,
  message = "جاري تحميل بياناتك...",
  subMessage = "يرجى الانتظار لحظة",
  children
}) => {
  if (!loading) {
    return children;
  }

  return (
    <div className="min-h-screen bg-[#FFF5F7] flex items-center justify-center relative overflow-hidden" translate="no">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 rounded-full bg-[#A73A5D]/10 blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 rounded-full bg-[#A73A5D]/10 blur-3xl"></div>
      </div>

      {/* Loading content */}
      <div className="relative z-10 text-center">
        {/* Logo area */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#A73A5D] rounded-full mb-4 relative">
            <Heart className="w-10 h-10 text-white" fill="currentColor" />
          </div>
        </div>

        {/* Loading spinner */}
        <div className="mb-6">
          <div className="relative">
            <Loader2 className="w-12 h-12 text-[#A73A5D] animate-spin mx-auto" />
            <Sparkles className="w-6 h-6 text-[#A73A5D] absolute -top-2 -right-2 animate-pulse" />
          </div>
        </div>

        {/* Loading text */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold text-gray-800 animate-pulse">
            {message}
          </h3>
          <p className="text-gray-600 text-sm animate-pulse delay-300">
            {subMessage}
          </p>
        </div>

        {/* Progress dots */}
        <div className="flex justify-center space-x-1 mt-6">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-2 h-2 bg-[#A73A5D] rounded-full animate-bounce"
              style={{ animationDelay: `${i * 0.2}s` }}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingWrapper;